module.exports = __webpack_public_path__ + "static/img/版权.97dff208.png";